import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { getBem } from 'umg-ember-backend/utils/get-bem';
import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

import Field from './field';
import Fieldset from './fieldset';
import Meta from './sections/meta';
import Seo from './sections/seo';
import Variant from './sections/variant';
import styles from './styles.module.css';

const bem = getBem(styles);

export default class UiForm extends Component {
  // Services
  @service abilities;
  @service breadcrumb;
  @service router;

  // Getter and setter
  get hasPermissionToEdit() {
    let action = this.args.model.isNew ? 'create' : 'update';

    return this.abilities.can(action, this.args.model, {
      parentModel: this.args.parentModel,
    });
  }

  // Functions
  registerFormModel = () => {
    let currentRoute = this.breadcrumb.currentRoute;

    if (this.args.disableRegisterToBreadcrumb) {
      return;
    }

    if (currentRoute) {
      currentRoute.findOrRegisterFormModel(this.args.model);
    }
  };

  preventDefault = (event) => {
    event.preventDefault();
    return false;
  };

  // Template
  <template>
    <form
      class={{(bem)}}
      {{on 'submit' this.preventDefault}}
      {{didInsert this.registerFormModel}}
      ...attributes
    >
      {{#let
        (hash
          field=(component
            Field
            formShowValidationErrors=@showErrors
            model=@model
            recordType=(getRecordType @model)
            hasPermissionToEdit=this.hasPermissionToEdit
          )
          fieldset=(component
            Fieldset
            formShowValidationErrors=@showErrors
            model=@model
            recordType=(getRecordType @model)
            hasPermissionToEdit=this.hasPermissionToEdit
          )
          formShowValidationErrors=@showErrors
          model=@model
          recordType=(getRecordType @model)
          hasPermissionToEdit=this.hasPermissionToEdit
        )
        as |form|
      }}
        {{yield
          (hash
            field=form.field
            fieldset=form.fieldset
            sections=(hash
              variant=(component Variant form=form)
              seo=(component Seo form=form)
              meta=(component Meta model=form.model)
            )
            model=form.model
            recordType=form.recordType
            showErrors=form.formShowValidationErrors
            hasPermissionToEdit=this.hasPermissionToEdit
          )
        }}
      {{/let}}
    </form>
  </template>
}
